import { Link } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';

import { useHaptics } from '@/hooks/useHaptics';
import { cn } from '@/lib/cn';

/**
 * Leaderboard pill — wide cyan radial-gradient button. Mirrors mobile-app's
 * `LeaderboardCart` (the secondary cart/shop button is omitted: Telegram
 * Stars / IAP is deferred to Phase 4).
 */
export function LeaderboardCart() {
  const haptics = useHaptics();

  return (
    <Link
      to="/leaderboards"
      onClick={() => haptics.impact('light')}
      className={cn(
        'flex h-11 items-center justify-center gap-2 rounded-lg border-2 border-brand px-6',
        'bg-[radial-gradient(circle_at_center,#00E7DF_0%,#05928C_100%)]',
        'text-xs font-bold uppercase tracking-wide text-[#123E3C]',
        'transition-opacity active:opacity-80',
      )}
    >
      <BarChart3 aria-hidden className="h-5 w-5" strokeWidth={2.5} />
      <span>Leaderboard</span>
    </Link>
  );
}
